/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_L9_NInputs */

const en_mk_sec_pg_l9_n = /** @type {(inputs: Mk_Sec_Pg_L9_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The application servers and database currently sit outside the country. In-country placement can be discussed for Enterprise needs.`)
};

const id_mk_sec_pg_l9_n = /** @type {(inputs: Mk_Sec_Pg_L9_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Server aplikasi dan basis data saat ini berada di luar negeri. Penempatan di dalam negeri bisa dibicarakan untuk kebutuhan Enterprise.`)
};

/**
* | output |
* | --- |
* | "The application servers and database currently sit outside the country. In-country placement can be discussed for Enterprise needs." |
*
* @param {Mk_Sec_Pg_L9_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_l9_n = /** @type {((inputs?: Mk_Sec_Pg_L9_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_L9_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_l9_n(inputs)
	return en_mk_sec_pg_l9_n(inputs)
});